import React from "react";

// Formats currency: adds thousand commas, strips trailing ".00", keeps real decimals.
// e.g. 7000 -> $7,000 | 14500.95 -> $14,500.95 | 10.00 -> $10 | 15.17 -> $15.17
const formatMoney = (value, fallback = "$0") => {
  const num = parseFloat(value);
  if (value === null || value === undefined || value === "" || isNaN(num)) {
    return fallback;
  }
  const formatted = num.toFixed(2).replace(/\.00$/, "");
  const parts = formatted.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return "$" + parts.join(".");
};

// Same as renderFfeBalanceCell in WHRevenueShareReport: red when a balance is remaining,
// green when it is zero. Title and total rows have no value, so they stay empty.
// These reports get the value as text like "$1,234.50", so "$" and commas are removed first.
const ffeBalanceCell = (value) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }
  const balance = parseFloat(String(value).replace(/[^0-9.-]/g, "") || 0);
  const cls = balance > 0 ? "ffe-balance-positive" : "ffe-balance-zero";
  return <span className={cls}>{formatMoney(balance)}</span>;
};

export default ffeBalanceCell;
